const translations = {
  InvoiceDeleteSucceed: 'Usunięcie faktury zostało zakończone sukcesem',
  InvoiceDeleteSucceedDescription: 'Usunięcie faktury zakończyło sie sukcesem. Numer usuniętej faktury: ',
  InvoiceDeleteFailed: 'Usunięcie faktury nie powiodło się',
  InvoiceDeleteFailedDescription: 'Faktura została wysłana do KSeF i nie może zostać usunięta',
  InvoiceCorrectionSucceed: 'Korekta faktury została utworzona',
  InvoiceCorrectionSucceedDescription: 'Numer faktury korygującej: ',
};

export default translations;
